import { Horizontal } from '@gravitate-js/excalibrr'
import type * as React from 'react'

import { useLaunchpadContext } from '../context'
import { SummaryCard } from './common/SummaryCard'

/**
 * Component that displays the summary metrics (base freight, accessorials, surcharge)
 */
export function MetricSummary() {
  const { data, costRevenue } = useLaunchpadContext()

  // Use the provided costRevenue or default to 'Revenue' if null
  const effectiveCostRevenue = costRevenue || 'Revenue'

  if (!data) {
    return null // Or add a loading state
  }

  const { metrics } = data

  return (
    <Horizontal gap={8} flex={5}>
      <SummaryCard
        label='Base Freight'
        value={metrics.baseFreight.total}
        percentage={metrics.baseFreight.percentage}
        items={metrics.baseFreight.topCustomers}
        type='Base Freight'
        topLevelLinkLabel='View base freight line items'
        costRevenue={effectiveCostRevenue}
      />
      <SummaryCard
        label='Accessorials'
        value={metrics.accessorials.total}
        percentage={metrics.accessorials.percentage}
        title='Top Accessorials'
        items={metrics.accessorials.topTypes}
        type='Accessorial'
        topLevelLinkLabel='View accessorial line items'
        costRevenue={effectiveCostRevenue}
      />
      <SummaryCard
        label='Surcharge'
        type='Surcharge'
        value={metrics.surcharge.total}
        percentage={metrics.surcharge.percentage}
        items={metrics.surcharge.topCustomers}
        topLevelLinkLabel='View surcharge line items'
        costRevenue={effectiveCostRevenue}
      />
    </Horizontal>
  )
}
